import Table from '@/components/Table'
import { TableData } from '@/components/Table/type'
import { useCarrierQuery } from '@/queries/useCarrierQuery'
import { Carrier } from '@/types/Carrier'
import { createColumnHelper } from '@tanstack/react-table'
import { useMemo } from 'react'
import DadosMestreHeader from '../components/DadosMestreHeader' 
import DadosMestreHeaderActions from '../components/DadosMestreHeaderActions' 
import DefaultColumn from '@/components/Table/components/DefaultColumn'
import { useTable } from '@/hooks/useTable'

export type CarrierTable = TableData<Carrier>

const columnHelper = createColumnHelper<Carrier>()

const MasterDataCarrier = () => {
    const {
        table,  
        selectedRows,  
        onClickMultiDelete, 
        setTable,
    } = useTable<Carrier>('')
  
    const { data, isFetching, isPending, refetch } = useCarrierQuery()
    
    const memoData = useMemo(() => data || [], [data])
    const memoColumns = useMemo(
        () => [
            columnHelper.accessor('NK_TRANSPORTADORA', {
                id: 'NK_TRANSPORTADORA',
                header: 'Cod. Transportadora',
                size: 140,
            }), 
            columnHelper.accessor('NM_RAZAO_SOCIAL', {
                id: 'NM_RAZAO_SOCIAL',
                header: 'Razão Social',
                size: 360,
            }),
            columnHelper.accessor('NM_FANTASIA', {
                id: 'NM_FANTASIA',
                header: 'Nome Fantasia',
                size: 260,
            }),
            columnHelper.accessor('DD_CNPJ', {
                id: 'DD_CNPJ',
                header: 'CNPJ',
                size: 160,
            }),  
        ],
        []
    )

    return (
        <div className="w-full h-full p-4 overflow-hidden">
            <Table<CarrierTable>
                data={memoData}
                columns={memoColumns}
                getRowId={(row) => row.SK_TRANSPORTADORA.toString()}
                isLoading={isPending}
                isFetching={isFetching}
                getTableInstance={(table) => setTable(table)} 
                tableHeader={
                    <DadosMestreHeader
                        title={`Transportadoras`}
                        onDelete={onClickMultiDelete}
                        selectedRows={
                            table
                                ?.getFilteredRowModel()
                                .flatRows.filter((row) => selectedRows[row.id])
                                .length
                        }
                    />
                }
                tableActions={
                    <DadosMestreHeaderActions 
                        onRefech={refetch} 
                    />
                } 
                defaultColumn={{
                    cell: ({ getValue }) => (
                        <DefaultColumn>{getValue() as string}</DefaultColumn>
                    ),
                }}
            /> 
        </div>
    )
}

export default MasterDataCarrier
